import { render, staticRenderFns } from "./ProductRedemption.vue?vue&type=template&id=0ceb23d9&scoped=true"
import script from "./ProductRedemption.vue?vue&type=script&lang=js"
export * from "./ProductRedemption.vue?vue&type=script&lang=js"
import style0 from "./ProductRedemption.vue?vue&type=style&index=0&id=0ceb23d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ceb23d9",
  null
  
)

export default component.exports